import React, { useState, useEffect } from "react";
import * as yup from "yup";
import {
  Button,
  Modal,
  Form as FormUi,
  Input,
  Checkbox,
  Dropdown,
} from "semantic-ui-react";
import { translate } from "react-i18next";
import DeleteAxios from "../axiosComponent/delete";
import DeleteDocumentAxios from "../axiosComponent/deletedocument";

const ModalDocumentDelete = (props) => {

    let DeleteItem = () => {
        DeleteDocumentAxios({
          completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/bl/${props.bl}/documents/${props.id}`,
        })
          .then((res) => {
            // let link = res.data;
            // link.setAttribute(link)
            props.success({
              type: "success",
              messageHeader: "Success",
              messageBody: res.message,
            });
            window.location.reload();
          })
          .catch((err) => {
            console.log(err);
          });
      }

    return (
        <Modal onClose={props.CloseModal} open={props.open} size="mini">
      <Modal.Header>{props.t("message.header") || "Alert"}</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <p>{props.t("message.info_mess") || "Are you sure you want to delete this File"}</p>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button
          color="green"
          size="mini"
          type="button"
          onClick={props.handleCancel}
        >
          {props.t("message.cancel") || "cancel"}
        </Button>
        <Button type="button" size="mini" color="blue" onClick={DeleteItem}>
          {props.t("message.ok") || "ok"}
        </Button>
      </Modal.Actions>
    </Modal>
    );
};

export default translate('shipment_details')(ModalDocumentDelete);